import { render, staticRenderFns } from "./CornerOrnament.vue?vue&type=template&id=146477c4&"
import script from "./CornerOrnament.vue?vue&type=script&lang=js&"
export * from "./CornerOrnament.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports